<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color} stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 21 15">
    <g clip-path="url(#clip0_7100_1489)">
      <path
        d="M15.0196 10.7226L14.664 10.557V10.9492V12.329C14.6617 13.695 13.6904 14.75 12.5576 14.75L3.13234 14.75C3.1322 14.75 3.13206 14.75 3.13192 14.75C1.99832 14.7473 1.02783 13.6944 1.02783 12.3295V2.67054C1.02783 1.30528 2.00106 0.25 3.13427 0.25H12.5598C13.6937 0.252613 14.6665 1.30593 14.6665 2.67054V4.05922V4.45226L15.0225 4.28565L19.6833 2.10424L19.6844 2.10368C19.7571 2.06922 19.8343 2.05202 19.9139 2.05191C20.2248 2.0542 20.5278 2.35453 20.5278 2.79142V12.2114C20.5278 12.3092 20.5104 12.4098 20.4781 12.5005C20.3363 12.8881 19.975 13.0292 19.6849 12.8954C19.6848 12.8953 19.6848 12.8953 19.6847 12.8953L15.0196 10.7226Z"
        :class="colorClass"
        stroke-width="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_7100_1489">
        <rect width="20" height="15" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
